import { Button } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import Chip from "components/Chip";
import TableComponent from "components/TableComponent";
import { Colors } from "constants/colors";
import DatePicker from "Modals/datePicker";
import React from "react";
import { useNavigate } from "react-router-dom";

type props = {
  rows: any;
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
};

const InvoiceAndPayments = ({
  rows,
  count,
  page,
  onPageChange,
  loading,
}: props) => {
  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const columns: GridColDef[] = [
    {
      flex: 0.4,
      minWidth: 100,
      field: "id",
      headerName: "Invoice ID",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>#AD001</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 200,
      field: "customer",
      headerName: "Customer",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>John</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 200,
      field: "type",
      headerName: "Type",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>Individual</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 200,
      field: "amount",
      headerName: "Amount",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>$ 7000</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Chip label="Paid" backgroundColor={Colors.primary} color="white" />
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "date",
      headerName: "Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>04/06/2025</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "dueDate",
      headerName: "Due Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>04/06/2025</p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "method",
      headerName: "Payment Method",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>Crypto</p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "actions",

      headerName: "Actions",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Button variant="outlined" color="inherit" size="small">
              Download
            </Button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div className="sorting_table">
        {/* <DatePicker open={true} onClose={() => {}} setOpen={() => {}} /> */}

        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default InvoiceAndPayments;
